import { BatchStatusEnum } from "../enums/batch-status.enum";
import { CompanyPlaceDTO } from "./CompanyPlaceDTO";

export class ProductFileGetDTO {
    Oid: number;
    Endpoint: string;
    Type: number;
    Private: boolean;

    constructor(data: any) {
        this.Oid = data.Oid;
        this.Endpoint = data.Endpoint;
        this.Type = data.Type;
        this.Private = data.Private;
    }
}

export class UserInfoFileGetDTO {
    Oid: number;
    Endpoint: string;
    Type: number;
    Private: boolean;

    constructor(data: any) {
        this.Oid = data.Oid;
        this.Endpoint = data.Endpoint;
        this.Type = data.Type;
        this.Private = data.Private;
    }
}

export class BatchPreviewDTO {
    Oid: number | null;
    TotalOffers?: number;
    Name: string | null;
    CreatedBy: string | null;
    Quantity: number | null;
    StartDate?: Date;
    EndDate?: Date;
    StartingPrice: number | null;
    ProductName: string | null;
    MeasuringUnit: MeasuringUnitEnum | null;
    ProductDescription: string | null;
    ProductQuantity: number | null;
    ProductFiles: ProductFileGetDTO[] | null;
    UserFile: UserInfoFileGetDTO | null;
    Status: BatchStatusEnum | null;
    RankingInfos?: BatchRankingPreviewDTO;
    Rankings?: Array<RankingDTO> | null;
    DeliveryStatus?: BatchDeliveryStatusEnum | null;
    PriceByMeasuringUnit: number | null;


    constructor(data: any) {

        this.Oid = data.Oid;
        this.Name = data.Name;
        this.CreatedBy = data.CreatedBy;
        this.Quantity = data.Quantity;
        this.StartingPrice = data.StartingPrice;
        this.ProductName = data.ProductName;
        this.ProductDescription = data.ProductDescription;
        this.ProductQuantity = data.ProductQuantity;
        this.ProductFiles = data.ProductFiles.map((file: any) => new ProductFileGetDTO(file));
        this.UserFile =  data.userFile ? new UserInfoFileGetDTO(data.UserFile) : null;

    }
}

export enum MeasuringUnitEnum{

    Box = 1,
    Package = 2,
    Weight = 3,
    Litre = 4

}

export class BatchRankingPreviewDTO{

    TotalBids?: number
    WinningBids?: number
    MyAmount?: number
    Place?: CompanyPlaceDTO

}

export class RankingDTO{
    Oid? : number;
    Amount?: number;
    Quantity?: number;
    PlaceOid?: number;
}

export enum BatchDeliveryStatusEnum{

    NotSet = 0,
    Delivering = 1,
    ReturnBack = 5,
    Delivered = 10,
    NotDelivered = 11,
    Cancelled = 15

}
